<template>
  <div class="new">
    <!-- [ Messages New form ] start -->
    <el-form :model="form" status-icon :rules="rules" ref="form" class="demo-ruleForm">

      <el-row :gutter="20">
        <el-col :span="8">
          <!-- Project -->
          <el-form-item v-if="messagesDirectories.projectCompanyUserList != null" prop="to">
            <el-select :disabled="isReply" no-data-text="no data" v-model="form.to" :placeholder="$t('project_tab_messages_first_btn_new_selectedTo')" filterable multiple style="width: 100%;">
              <el-option
                v-for="item in messagesDirectories.projectCompanyUserList"
                :key="item.companyUserId"
                :label="item.userFullName"
                :value="item.companyUserId">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="messagesDirectories.projectTaskCompanyUserList != null" prop="to">
            <el-select :disabled="isReply" no-data-text="no data" v-model="form.to" :placeholder="$t('project_tab_messages_first_btn_new_selectedTo')" filterable multiple style="width: 100%;">
              <el-option
                v-for="item in messagesDirectories.projectTaskCompanyUserList"
                :key="item.companyUserId"
                :label="item.userFullName"
                :value="item.companyUserId">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- businessUnit -->
          <el-form-item v-if="messagesDirectories.businessUnitCompanyUserList != null" prop="to">
            <el-select :disabled="isReply" no-data-text="no data" v-model="form.to" :placeholder="$t('project_tab_messages_first_btn_new_selectedTo')" filterable multiple style="width: 100%;">
              <el-option
                v-for="item in messagesDirectories.businessUnitCompanyUserList"
                :key="item.companyUserId"
                :label="item.userFullName"
                :value="item.companyUserId">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="messagesDirectories.businessUnitTaskCompanyUserList != null" prop="to">
            <el-select :disabled="isReply" no-data-text="no data" v-model="form.to" :placeholder="$t('project_tab_messages_first_btn_new_selectedTo')" filterable multiple style="width: 100%;">
              <el-option
                v-for="item in messagesDirectories.businessUnitTaskCompanyUserList"
                :key="item.companyUserId"
                :label="item.userFullName"
                :value="item.companyUserId">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- Engagement -->
          <el-form-item v-if="messagesDirectories.engagementCompanyUserList != null" prop="to">
            <el-select :disabled="isReply" no-data-text="no data" v-model="form.to" :placeholder="$t('project_tab_messages_first_btn_new_selectedTo')" filterable multiple style="width: 100%;">
              <el-option
                      v-for="item in messagesDirectories.engagementCompanyUserList"
                      :key="item.companyUserId"
                      :label="item.userFullName"
                      :value="item.companyUserId">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="messagesDirectories.engagementTaskCompanyUserList != null" prop="to">
            <el-select :disabled="isReply" no-data-text="no data" v-model="form.to" :placeholder="$t('project_tab_messages_first_btn_new_selectedTo')" filterable multiple style="width: 100%;">
              <el-option
                v-for="item in messagesDirectories.engagementTaskCompanyUserList"
                :key="item.companyUserId"
                :label="item.userFullName"
                :value="item.companyUserId">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="priority">
            <el-select no-data-text="no data" v-model="form.priority" :placeholder="$t('project_tab_messages_first_btn_new_selectedPriority')" filterable style="width: 100%;">
              <el-option
                v-for="item in messagesDirectories.priorityList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="status">
            <el-select no-data-text="no data" v-model="form.status" :placeholder="$t('project_tab_messages_first_btn_new_selectedStatus')" filterable style="width: 100%;">
              <el-option
                v-for="item in status"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item prop="messageTitle">
        <el-input v-model="form.messageTitle" class="inp" :placeholder="$t('project_tab_messages_first_btn_new_messageTitle')"></el-input>
      </el-form-item>

      <vue2-custom-editor
        v-model="form.message"
        ref="editor">
      </vue2-custom-editor>

      <el-form-item class="modal__btn">
        <el-button @click="submitForm('form')" type="primary" plain size="mini">{{$t('project_tab_messages_first_btn_new_btn_sendMessage')}}</el-button>
      </el-form-item>

    </el-form>
    <!-- [ Messages New form ] end -->

  </div>
</template>

<script>
import axios from 'axios'
import Vue2CustomEditor from "../../vue-2-custom-editor";
export default {
  components: {
    Vue2CustomEditor
  },
  props: ['type', 'activeProjectId', 'selectedRow', 'list', 'isReply'],
  computed: {
    messagesDirectories() {
      return this.$store.state.messagesDirectories
    },
  },
  watch: {},
  data() {
    return {
      status: {
        0: {
          id: 1,
          name: 'For Action'
        },
        1: {
          id: 2,
          name: 'For Comment'
        },
        2: {
          id: 3,
          name: 'For Information Only'
        }
      },
      form: {
        to: [],
        priority: '',
        status: '',
        messageTitle: '',
        message: '',
      },
      rules: {
        to: [{
          required: true,
          message: 'To Group is required',
          trigger: 'change'
        }],
        priority: [{
          required: true,
          message: 'Priority is required',
          trigger: 'change'
        }],
        status: [{
          required: true,
          message: 'Status is required',
          trigger: 'change'
        }],
        messageTitle: [{
          required: true,
          message: 'Message Title is required',
          trigger: 'change'
        }],
        // message: [{
        //   required: true,
        //   message: 'Message is required',
        //   trigger: 'change'
        // }],
      }
    }
  },
  mounted () {
    this.watchReplyList();
  },
  methods: {
    watchReplyList() {
      if (this.list !== null) {
        this.form.to[0] = this.list.fromCompanyUser.id
        this.form.messageTitle = 'Re: ' + this.list.subject
        this.form.message = '<br><br><p style="color: #ccc;">---------- Replied Message ---------</p>' + this.list.text
      }
    },
    submitForm(form) {
      this.$refs[form].validate((valid) => {
        if (valid && this.form.message) {
          console.log('submit');
          if (this.type == 'task') {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/projectTaskMessages/create?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}&projectTaskId=${this.selectedRow.id}`,
              {
                subject: this.form.messageTitle,
                text: this.form.message,
                toCompanyUserIdList: this.form.to,
                priorityId: this.form.priority,
                actionType: this.form.status,
              })
              .then(response => {
                console.log('---/projectTaskMessages/create', response.data);
                if (this.$refs.editor.uploadedImagesArray.length) {
                  this.$store.dispatch('approveUploadedImages', {
                    fileUrlArr: this.$refs.editor.uploadedImagesArray,
                    entityId: response.data.projectTaskMessageId,
                    entityTypeId: 28 // project task message
                  })
                }
                // if (this.$refs.editor.removedImages.length) this.$store.dispatch('deleteRemovedImages', this.$refs.editor.removedImages)
                this.notification("Success", "Message Sent", "success");
                this.$refs['form'].resetFields();
                this.form.message = ''
                this.$emit('turnOffIsReplay')
                // if(this.isReply){
                //   this.isReply = false
                // }
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
          } else if (this.type == 'project') {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/projectMessages/create?companyId=${this.$route.query.companyId}&projectId=${this.activeProjectId}`,
              {
                subject: this.form.messageTitle,
                text: this.form.message,
                toCompanyUserIdList: this.form.to,
                priorityId: this.form.priority,
                actionType: this.form.status,
              })
              .then(response => {
                if (this.$refs.editor.uploadedImagesArray.length) {
                  this.$store.dispatch('approveUploadedImages', {
                    fileUrlArr: this.$refs.editor.uploadedImagesArray,
                    entityId: response.data.projectMessageId,
                    entityTypeId: 4 // project message
                  })
                }
                // if (this.$refs.editor.removedImages.length) this.$store.dispatch('deleteRemovedImages', this.$refs.editor.removedImages)
                console.log('---/projectMessages/create', response.data);
                this.notification("Success", "Message Sent", "success");
                this.$refs['form'].resetFields();
                this.form.message = ''
                // if(this.isReply){
                //   this.isReply = false
                // }
                this.$emit('turnOffIsReplay')
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
          } else if (this.type == 'taskBusinessUnit') {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/businessUnitTaskMessages/create?companyId=${this.$route.query.companyId}&businessUnitId=${this.activeProjectId}&businessUnitTaskId=${this.selectedRow.id}`,
              {
                subject: this.form.messageTitle,
                text: this.form.message,
                toCompanyUserIdList: this.form.to,
                priorityId: this.form.priority,
                actionType: this.form.status,
              })
              .then(response => {
                console.log('---/businessUnitTaskMessages/create', response.data);
                if (this.$refs.editor.uploadedImagesArray.length) {
                  this.$store.dispatch('approveUploadedImages', {
                    fileUrlArr: this.$refs.editor.uploadedImagesArray,
                    entityId: response.data.businessUnitTaskMessageId,
                    entityTypeId: 46 // bu task message
                  })
                }
                // if (this.$refs.editor.removedImages.length) this.$store.dispatch('deleteRemovedImages', this.$refs.editor.removedImages)
                this.notification("Success", "Message Sent", "success");
                this.$refs['form'].resetFields();
                this.form.message = ''
                // if(this.isReply){
                //   this.isReply = false
                // }
                this.$emit('turnOffIsReplay')
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
          } else if (this.type == 'businessUnit') {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
              .post(`/api/v1/businessUnitMessages/create?companyId=${this.$route.query.companyId}&businessUnitId=${this.activeProjectId}`,
              {
                subject: this.form.messageTitle,
                text: this.form.message,
                toCompanyUserIdList: this.form.to,
                priorityId: this.form.priority,
                actionType: this.form.status,
              })
              .then(response => {
                console.log('---/businessUnitMessages/create', response.data);
                if (this.$refs.editor.uploadedImagesArray.length) {
                  this.$store.dispatch('approveUploadedImages', {
                    fileUrlArr: this.$refs.editor.uploadedImagesArray,
                    entityId: response.data.businessUnitMessageId,
                    entityTypeId: 20 // bu message
                  })
                }
                // if (this.$refs.editor.removedImages.length) this.$store.dispatch('deleteRemovedImages', this.$refs.editor.removedImages)
                this.notification("Success", "Message Sent", "success");
                this.$refs['form'].resetFields();
                this.form.message = ''
                // if(this.isReply){
                //   this.isReply = false
                // }
                this.$emit('turnOffIsReplay')
                loader.hide()
              })
              .catch(error => {
                console.log('An error occurred:', error);
                loader.hide()
              });
          }else if (this.type == 'engagement') {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                    .post(`/api/v1/engagementMessages/create?companyId=${this.$route.query.companyId}&engagementId=${this.activeProjectId}`,
                            {
                              subject: this.form.messageTitle,
                              text: this.form.message,
                              toCompanyUserIdList: this.form.to,
                              priorityId: this.form.priority,
                              actionType: this.form.status,
                            })
                    .then(response => {
                      console.log('---/engagementMessages/create', response.data);
                      if (this.$refs.editor.uploadedImagesArray.length) {
                        this.$store.dispatch('approveUploadedImages', {
                          fileUrlArr: this.$refs.editor.uploadedImagesArray,
                          entityId: response.data.engagementMessageId,
                          entityTypeId: 12 // engagement message
                        })
                      }
                      // if (this.$refs.editor.removedImages.length) this.$store.dispatch('deleteRemovedImages', this.$refs.editor.removedImages)
                      this.notification("Success", "Message Sent", "success");
                      this.$refs['form'].resetFields();
                      this.form.message = ''
                      // if(this.isReply){
                      //   this.isReply = false
                      // }
                      this.$emit('turnOffIsReplay')
                      loader.hide()
                    })
                    .catch(error => {
                      console.log('An error occurred:', error);
                      loader.hide()
                    });
          }else if (this.type == 'taskEngagement') {
            let loader = this.$loading.show();
            axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
            axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
            axios
                    .post(`/api/v1/engagementTaskMessages/create?companyId=${this.$route.query.companyId}&engagementId=${this.activeProjectId}&engagementTaskId=${this.selectedRow.id}`,
                            {
                              subject: this.form.messageTitle,
                              text: this.form.message,
                              toCompanyUserIdList: this.form.to,
                              priorityId: this.form.priority,
                              actionType: this.form.status,
                            })
                    .then(response => {
                      console.log('---/engagementTaskMessages/create', response.data);
                      if (this.$refs.editor.uploadedImagesArray.length) {
                        this.$store.dispatch('approveUploadedImages', {
                          fileUrlArr: this.$refs.editor.uploadedImagesArray,
                          entityId: response.data.engagementTaskMessageId,
                          entityTypeId: 37 // engagement task message
                        })
                      }
                      // if (this.$refs.editor.removedImages.length) this.$store.dispatch('deleteRemovedImages', this.$refs.editor.removedImages)
                      this.notification("Success", "Message Sent", "success");
                      this.$refs['form'].resetFields();
                      this.form.message = ''
                      // if(this.isReply){
                      //   this.isReply = false
                      // }
                      this.$emit('turnOffIsReplay')
                      loader.hide()
                    })
                    .catch(error => {
                      console.log('An error occurred:', error);
                      loader.hide()
                    });
          }

        } else {
          if (!this.form.message) {
            this.notification("Info", "Enter your message", "info");
          } else {
            this.notification("Info", "Fill in all the fields", "info");
          }
          console.log('error submit!!');
          return false;
        }
      });
    },
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.new {}
.header {
  display: flex;
  justify-content: space-between;
}
// .modal__btn {
//   text-align: right;
// }

/deep/.ql-editor {
  height: 350px !important;
}
</style>

<style lang="scss">
.inp{
  box-sizing: border-box;
  .el-input__inner{
    width: 100%;
  }
}
</style>
